var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo"},[_c('img',{staticClass:"w-full h-full cursor-pointer",attrs:{"src":_vm.thumbnailData},on:{"click":function($event){return _vm.$store.dispatch('openLightTable', _vm.id)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }